import axios from 'axios'
import { EventResponseItem } from '@/types/Event'
import { NewsResponseItem } from '@/types/News'
import { TopSpecialFeaturesResponseItem } from '@/types/TopSpecialFeatures'
import { convertNewsItem } from '@/repositories/converters/newsConverter'
import { convertEventItem } from '@/repositories/converters/eventConverter'
import { convertMiniNews } from './converters/miniNewsConverter'
import { convertTopSpecialFeaturesItem } from './converters/topSpecialFeaturesConverter'

const WP_API_BASE_URL = process.env.VUE_APP_WPAPI_URL || ''
const WP_API_TIMEOUT = 30000
const WP_API_BASIC_AUTH = {
  username: process.env.VUE_APP_WPAPI_USER || '',
  password: process.env.VUE_APP_WPAPI_PASS || ''
}

const wpRestApiV2 = axios.create({
  baseURL: `${WP_API_BASE_URL}/wp-json/wp/v2/`,
  auth: WP_API_BASIC_AUTH,
  timeout: WP_API_TIMEOUT
})

const wpRestApiV3 = axios.create({
  baseURL: `${WP_API_BASE_URL}/wp-json/acf/v3/options/options/`,
  auth: WP_API_BASIC_AUTH,
  timeout: WP_API_TIMEOUT
})

export async function getMiniNews() {
  const res = await wpRestApiV3.get('module_mini_news')
  return {
    ...res,
    data: convertMiniNews(res.data)
  }
}

export async function getNews(perPage = 5) {
  const res = await wpRestApiV2.get(`news?per_page=${perPage}`)
  return {
    ...res,
    data: res.data.map((item: NewsResponseItem) => convertNewsItem(item)) || []
  }
}

export async function getEvents({
  perPage = 100,
  isArchived
}: {
  perPage: number
  isArchived?: boolean
}) {
  const params = new URLSearchParams()
  params.append('per_page', `${perPage}`)
  if (isArchived) {
    params.append('archive_flag', '1')
  }
  const res = await wpRestApiV2.get(`event?${params.toString()}`)
  const data = res.data.map((item: EventResponseItem) => convertEventItem(item))
  return {
    ...res,
    data: data || []
  }
}

export async function getTopSpecialFeatures() {
  const res = await wpRestApiV2.get('top_special_features')
  return {
    ...res,
    data: res.data.map((item: TopSpecialFeaturesResponseItem) => {
      return convertTopSpecialFeaturesItem(item)
    })
  }
}
